import React from 'react';
import Image from 'next/image';
import { NodeRenderer } from '@contentful/rich-text-react-renderer';

// This is most likely unused code.
export const EmbeddedAsset = (({ data: { target } }) => {
  const { fields } = target;
  const isVideo = fields.file.contentType.includes('video');

  // @TODO include video rich text at a later date
  if (isVideo) {
    return (
      // <Video
      //   sys={sys}
      //   // Change fields format to what <Image /> expects
      //   fields={fields}
      //   toPlainObject={noop as any}
      //   update={noop as any}
      // />
      <div>yay Video</div>
    );
  }

  const isImage = fields.file.contentType.includes('image');

  if (isImage) {
    const { title, file } = fields;
    const { url } = file;
    return <Image src={`https:${url}`} height={400} width={400} alt={title} />;
  }

  // Ignore all other asset types, e.g. PDFs, other docs etc.
  return null;
}) as NodeRenderer;
